<template>
	<Card
		:size
		:title
		bordered
		content-class="divide-border flex flex-col divide-y px-6!"
		:embedded
		header-class="p-6!"
	>
		<p v-if="description" class="pb-6">{{ description }}</p>

		<div v-for="item of list" :key="item.label" class="flex items-center justify-between gap-4 py-3.5">
			<div class="text-tertiary text-fs-base font-medium">{{ item.label }}</div>
			<div class="text-fs-base text-right font-medium">
				{{ stringFormat(item.value) }}
			</div>
		</div>
	</Card>
</template>

<script setup lang="ts">
import type { CardSize } from "naive-ui"
import Card from "@/components/common/Card.vue"
import { dFormat, isDate } from "@/utils/dayjs"

export type TransformerValue = string | Date | number | null | object
export type Transformer = (val?: TransformerValue) => TransformerValue

const {
	list,
	embedded,
	dateAutodetect,
	size = "small",
	title,
	description
} = defineProps<{
	list: { label: string; value: string }[]
	embedded?: boolean
	dateAutodetect?: boolean
	size?: CardSize
	title?: string
	description?: string | null
}>()

function stringFormat(val?: string | Date | number | null) {
	if (dateAutodetect && isDate(val)) {
		return dFormat(val, "date")
	}

	return val
}
</script>
